import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import './index.css'
import './styles/mobile-safe-areas.css'

// Prewarm Stockfish engine on app startup (deferred to not block FCP)
import { runEngineDiagnostics, logEngineStatus } from './lib/engine-diagnostics'
import { prewarmStockfish } from './lib/stockfish-engine'
createRoot(document.getElementById("root")!).render(<App />);

// Non-blocking engine prewarm (idle callback or timeout fallback)
const ric: any = (window as any).requestIdleCallback || ((cb: Function) => setTimeout(cb as any, 200));
ric(() => {
  prewarmStockfish().catch((e) => console.warn('[App] prewarmStockfish failed:', e));
});

// Defer engine diagnostics to improve First Contentful Paint
setTimeout(() => {
  runEngineDiagnostics().then(() => {
    logEngineStatus()
  }).catch((error) => {
    console.warn('[App] Engine diagnostics failed:', error)
  })
}, 100);
